import React from 'lib/react';
import {
  EVBox,
} from 'lib/components';
import { useDispatch, useSelector } from 'lib/redux';
import Map from 'commonComponents/map';
import { updateFocusedPointIndex } from 'features/order/Order.actions';
import { isEntitledForEmbeddedExplorerSelector } from 'utils/appSelectors.utils';
import orderSubmittedMapStyles from './OrderSubmittedMapStyles';

function orderSubmittedMap() {
  const dispatch = useDispatch();
  const {
    mapPoints,
    isComplex,
    propertyType,
    focusedPointIndex,
    useEmbeddedExplorer,
  } = useSelector(({ orderSubmitted, orderAddresses }) => ({
    mapPoints: orderSubmitted.mapPoints,
    isComplex: orderSubmitted.isComplex,
    propertyType: orderSubmitted.propertyType,
    focusedPointIndex: orderAddresses.focusedPointIndex,
    useEmbeddedExplorer: orderSubmitted.useEmbeddedExplorer,
  }));

  const isEntitledForEmbeddedExplorer = useSelector(isEntitledForEmbeddedExplorerSelector);

  const classes = orderSubmittedMapStyles();

  const handleFocusChange = (index) => dispatch(updateFocusedPointIndex((index === focusedPointIndex) ? null : index));

  return (
    <EVBox className={classes.mapContainer}>
      <Map
        useEmbeddedExplorer={isEntitledForEmbeddedExplorer && useEmbeddedExplorer}
        mapPoints={mapPoints}
        isComplex={isComplex}
        propertyType={propertyType}
        focusedPinIndex={focusedPointIndex}
        onFocusChange={handleFocusChange}
        mapOptions={{ showMapTypeSelector: false }}
      />
    </EVBox>
  );
}

export default orderSubmittedMap;
